module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary create-model-btn",
    on: {
      "click": function($event) {
        _vm.showModel('create')
      }
    }
  }, [_vm._v("\n    Create New\n  ")]), _vm._v(" "), (_vm.showModal) ? _c('CreateModel', {
    attrs: {
      "modelType": _vm.modelType
    },
    on: {
      "close": function($event) {
        _vm.closeModal()
      },
      "openModal": _vm.ModelCreated
    }
  }) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "model-history"
  }, [_vm._m(1), _vm._v(" "), _c('demo-grid', {
    attrs: {
      "data": _vm.gridData,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery,
      "pagination": _vm.pagination,
      "sortKeys": _vm.sortKeys
    },
    on: {
      "pageChange": function($event) {
        _vm.pageChange($event, 'pagination')
      },
      "showModel": _vm.showModel
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "loadingtext"
  }, [_vm._v(_vm._s(_vm.loadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "steps-heading clearfix"
  }, [_c('span', [_vm._v("Model Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('strong', [_vm._v("Existing Models")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f20cea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Model-history.vue
// module id = 310
// module chunks = 1